// 5. pád křestního jména pro pozdrav na úvodu (236): „Dobrý den, Petře“.
// Pravidla jen pro běžné české koncovky; cizí jméno, které do nich nesedí,
// se nechá v 1. pádě (radši „Huynh“ než zkomolenina).
const VOWELS = "aáeéěiíoóuúůyý";
const isVowel = (c) => VOWELS.includes(c);

export function vocative(first) {
  const n = String(first || "").trim();
  if (n.length < 2) return n;
  const low = n.toLowerCase();
  const last = low.slice(-1), prev = low.slice(-2, -1);
  const keep = (k, add) => n.slice(0, n.length - k) + add;
  if (last === "a") return keep(1, "o");                       // Jana → Jano, Jirka → Jirko
  if ("eěiíoóuúůyý".includes(last)) return n;                 // Marie, Jiří, Ondra… beze změny
  if (low.endsWith("ek") && low.length > 3) return keep(2, "ku");   // Marek → Marku, Radek → Radku
  if (low.endsWith("něk")) return keep(3, "ňku");
  if (low.endsWith("ěk")) return keep(2, "ku");
  if (low.endsWith("el") && !isVowel(low.slice(-3, -2))) return keep(2, "le");   // Pavel → Pavle
  if (last === "r") return isVowel(prev) ? n + "e" : keep(1, "ře");   // Igor → Igore, Petr → Petře
  if (low.endsWith("ch") || "kg".includes(last)) return n + "u";   // Patrik → Patriku, Oldřich → Oldřichu
  if ("šžčřcjx".includes(last)) return n + "i";                // Lukáš → Lukáši, Ondřej → Ondřeji
  if ("nmdtbpvflsz".includes(last)) return n + "e";            // Jan → Jane, David → Davide
  return n;
}
